export const PERMISSIONS = {
  USER_ROLE_CONFIG: 135,
  ROLE_PERMISSION_CONFIG: 140,
  TOGGLE_AIS: 136,
  IRISS_ACCESS: 151,
  LOG_ACCESS: 178,
  ADMIN: 202,
  SIGNIFICANT_EVENTS_VIEW: 193,
  SIGNIFICANT_EVENTS_ADMIN: 194,
  SIGNIFICANT_EVENTS_CREATE: 195,
  ROAD_CLOSURES_VIEW: 196,
  ROAD_CLOSURES_EDIT: 197,
  ROAD_CLOSURES_ADMIN: 198,
  SITREP_VIEW: 199,
  SITREP_EDIT: 200,
  SITREP_ADMIN: 201,
  HCFR_ACTIVE_INCIDENTS_VIEW: 210,
  POWER_OUTAGES_VIEW: 211,
  PALMETTO_VIEW: 209,
  // PALMETTO_EDIT: 0,
  // PALMETTO_ADMIN: 0,
}
